export function emSeparator() {
	// Check if the separator has CSS class ".is-style-line-decorative" and than use WEB api interext observer to add CSS class in-viewport" when the separator is in the viewport.
	const separators = document.querySelectorAll('.wp-block-separator.is-style-line-decorative');
	separators.forEach((separator) => {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					separator.classList.add('in-viewport');
				} else {
					separator.classList.remove('in-viewport');
				}
			});
		});
		observer.observe(separator);
	});
}

document.addEventListener('DOMContentLoaded', () => {
	emSeparator();
});
